// Human in the loop — the one date helper. Every date on a Patient credit item
// is computed from its posting date with these (AGENT_GUIDE rule 12). ISO
// yyyy-mm-dd strings in, ISO strings out; all math in UTC so no DST drift.

const MONTHS3 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DAY_MS = 86_400_000;

function toUtc(iso: string): number {
  const [y, m, d] = iso.split('-').map(Number);
  return Date.UTC(y ?? 1970, (m ?? 1) - 1, d ?? 1);
}

function fromUtc(ms: number): string {
  const d = new Date(ms);
  return `${String(d.getUTCFullYear())}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

/** ISO date plus `n` days (n may be negative). Oct 15 2026 + 90 → 2027-01-13. */
export function addDays(iso: string, n: number): string {
  return fromUtc(toUtc(iso) + n * DAY_MS);
}

/** Whole days from `fromIso` to `toIso` (negative when `toIso` is earlier). */
export function daysBetween(fromIso: string, toIso: string): number {
  return Math.round((toUtc(toIso) - toUtc(fromIso)) / DAY_MS);
}

/** "Jan 13" */
export function fmtMonthDay(iso: string): string {
  const [, m, d] = iso.split('-').map(Number);
  return `${MONTHS3[(m ?? 1) - 1] ?? 'Jan'} ${String(d ?? 1)}`;
}

/** "Jan 13, 2027" */
export function fmtMonthDayYear(iso: string): string {
  const [y] = iso.split('-').map(Number);
  return `${fmtMonthDay(iso)}, ${String(y ?? 1970)}`;
}
